import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import LegalLayout from "../../layouts/LegalLayout";

const TermsAndConditions: React.FC = () => {
  const { t } = useTranslation();

  return (
    <LegalLayout>
      <Box sx={{ py: 4 }}>
        <Typography variant="h2" component="h1" gutterBottom>
          {t("legal.termsAndConditions.title")}
        </Typography>
        <Typography variant="body1">
          <strong>{t("legal.termsAndConditions.intro")}</strong>
          <br />
          <br />
          <strong>1. {t("legal.termsAndConditions.companyInfo.title")}</strong>
          <br />
          {t("legal.termsAndConditions.companyInfo.name")}
          <br />
          {t("legal.termsAndConditions.companyInfo.nif")}
          <br />
          {t("legal.termsAndConditions.companyInfo.address")}
          <br />
          {t("legal.termsAndConditions.companyInfo.contact")}
          <br />
          <br />
          <strong>2. {t("legal.termsAndConditions.purpose.title")}</strong>
          <br />
          {t("legal.termsAndConditions.purpose.description")}
          <br />
          <br />
          <strong>
            3. {t("legal.termsAndConditions.userObligations.title")}
          </strong>
          <br />
          {t("legal.termsAndConditions.userObligations.description")}
          <br />
          <br />
          <strong>
            4. {t("legal.termsAndConditions.dataProtection.title")}
          </strong>
          <br />
          {t("legal.termsAndConditions.dataProtection.description")}
          <br />
          <br />
          <strong>
            5. {t("legal.termsAndConditions.limitationOfLiability.title")}
          </strong>
          <br />
          {t("legal.termsAndConditions.limitationOfLiability.description")}
          <br />
          <br />
          <strong>6. {t("legal.termsAndConditions.governingLaw.title")}</strong>
          <br />
          {t("legal.termsAndConditions.governingLaw.description")}
          <br />
          <br />
          <strong>
            7. {t("legal.termsAndConditions.modifications.title")}
          </strong>
          <br />
          {t("legal.termsAndConditions.modifications.description")}
        </Typography>
      </Box>
    </LegalLayout>
  );
};

export default TermsAndConditions;
